/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/el';
const locale = {
  "add_8523c19b": {
    "message": "Πρόσθεση"
  },
  "add_one_9e34a6f8": {
    "message": "Προσθήκη!"
  },
  "all_4321c3a1": {
    "message": "Όλα"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "announcement_fb4cb645": {
    "message": "Ανακοίνωση"
  },
  "announcement_list_da155734": {
    "message": "Λίστα Ανακοινώσεων"
  },
  "announcements_a4b8ed4a": {
    "message": "Ανακοινώσεις"
  },
  "apply_781a2546": {
    "message": "Εφαρμογή"
  },
  "apps_54d24a47": {
    "message": "Εφαρμογές"
  },
  "arrows_464a3e54": {
    "message": "Βέλη"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Ο λόγος του μήκους της εικόνας προς το ύψος της θα διατηρηθεί"
  },
  "assignment_976578a8": {
    "message": "Εργασία"
  },
  "assignments_1e02582c": {
    "message": "Εργασίες"
  },
  "attributes_963ba262": {
    "message": "Πεδία"
  },
  "basic_554cdc0a": {
    "message": "Βασική"
  },
  "blue_daf8fea9": {
    "message": "Μπλε"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Ακύρωση"
  },
  "characters_9d897d1c": {
    "message": "Χαρακτήρες"
  },
  "choose_usage_rights_33683854": {
    "message": "Επιλέξτε δικαιώματα χρήσης..."
  },
  "clear_2084585f": {
    "message": "Καθαρισμός"
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Κάντε κλικ για να ενσωματώσετε την εικόνα { imageName }"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Κάντε κλικ για να εισάγετε σύνδεσμο μέσα στον επεξεργαστή"
  },
  "close_d634289d": {
    "message": "Κλείσιμο"
  },
  "collaborations_5c56c15f": {
    "message": "Συνεργασίες"
  },
  "color_a363e1b0": {
    "message": "Χρώμα"
  },
  "content_1440204b": {
    "message": "Περιεχόμενο"
  },
  "content_type_2cf90d95": {
    "message": "Τύπος Περιεχομένου"
  },
  "copyright_holder_66ee111": {
    "message": "Κάτοχος Πνευματικών Δικαιωμάτων:"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {}\n  other {}\n}"
  },
  "course_files_62deb8f8": {
    "message": "Αρχεία Μαθήματος"
  },
  "course_files_a31f97fc": {
    "message": "Αρχεία μαθήματος"
  },
  "course_navigation_dd035109": {
    "message": "Πλοήγηση στο μάθημα"
  },
  "creative_commons_license_725584ae": {
    "message": "Άδεια Creative Commons:"
  },
  "cyan_c1d5f68a": {
    "message": "Κυανό"
  },
  "decrease_indent_d9cf469d": {
    "message": "Μείωση Εσοχής Κειμένου"
  },
  "deep_purple_bb3e2907": {
    "message": "Βαθύ μοβ"
  },
  "delimiters_4db4840d": {
    "message": "Οριοθέτες"
  },
  "description_436c48d7": {
    "message": "Περιγραφή"
  },
  "details_98a31b68": {
    "message": "Λεπτομέρειες"
  },
  "discussion_6719c51d": {
    "message": "Συζήτηση"
  },
  "discussions_a5f96392": {
    "message": "Συζητήσεις"
  },
  "discussions_index_6c36ced": {
    "message": "Ευρετήριο Συζητήσεων"
  },
  "done_54e3d4b6": {
    "message": "Ολοκληρώθηκε"
  },
  "down_5831a426": {
    "message": "Κάτω"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "<mrk mid=\"4290\" mtype=\"seg\">Καταληκτική Ημερ/νία:</mrk> <mrk mid=\"4291\" mtype=\"seg\">Πολλαπλές Ημερομηνίες</mrk>"
  },
  "edit_c5fbea07": {
    "message": "Διαμόρφωση"
  },
  "embed_image_1080badc": {
    "message": "Ενσωμάτωση εικόνας"
  },
  "external_tools_6e77821": {
    "message": "Εξωτερικά Εργαλεία"
  },
  "files_c300e900": {
    "message": "Αρχεία"
  },
  "files_index_af7c662b": {
    "message": "Ευρετήριο Αρχείων"
  },
  "find_8d605019": {
    "message": "Εύρεση"
  },
  "format_4247a9c5": {
    "message": "Τύπος"
  },
  "generating_preview_45b53be0": {
    "message": "Δημιουργία προεπισκόπησης..."
  },
  "grades_a61eba0a": {
    "message": "Βαθμοί"
  },
  "greek_65c5b3f7": {
    "message": "Ελληνικά"
  },
  "green_15af4778": {
    "message": "Πράσινο"
  },
  "group_files_82e5dcdb": {
    "message": "Αρχεία ομάδας"
  },
  "group_navigation_99f191a": {
    "message": "Πλοήγηση στην Ομάδα"
  },
  "home_351838cd": {
    "message": "Αρχική Σελίδα"
  },
  "html_editor_fb2ab713": {
    "message": "Επεξεργαστής HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Πήρα άδεια για να χρησιμοποιήσω αυτό το αρχείο."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Έχω τα πνευματικά δικαιώματα"
  },
  "icon_215a1dc6": {
    "message": "Εικονίδιο"
  },
  "image_8ad06": {
    "message": "Εικόνα"
  },
  "images_7ce26570": {
    "message": "Εικόνες"
  },
  "increase_indent_6af90f7c": {
    "message": "Αύξηση Εσοχής Κειμένου"
  },
  "indigo_2035fc55": {
    "message": "Λουλακί"
  },
  "insert_593145ef": {
    "message": "Εισαγωγή"
  },
  "insert_link_6dc23cae": {
    "message": "Εισαγωγή Συνδέσμου"
  },
  "insert_math_equation_57c6e767": {
    "message": "Εισαγωγή Μαθηματικής Εξίσωσης"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Μη έγκυρος τύπος αρχείου"
  },
  "invalid_url_cbde79f": {
    "message": "Μη έγκυρο URL"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Συντομεύσεις πληκτρολογίου"
  },
  "light_blue_5374f600": {
    "message": "Μπλε Ανοιχτό"
  },
  "link_7262adec": {
    "message": "Σύνδεσμος"
  },
  "links_14b70841": {
    "message": "Σύνδεσμοι"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Σύνδεσμοι σε εξωτερική ιστοσελίδα."
  },
  "loading_25990131": {
    "message": "Φόρτωση..."
  },
  "loading_bde52856": {
    "message": "Φόρτωση"
  },
  "loading_failed_b3524381": {
    "message": "Η Φόρτωση Απέτυχε"
  },
  "locked_762f138b": {
    "message": "Κλειδωμένο"
  },
  "media_af190855": {
    "message": "Δεδομένα"
  },
  "minimize_file_preview_da911944": {
    "message": "Ελαχιστοποίηση Προεπισκόπησης Αρχείου"
  },
  "minimize_video_20aa554b": {
    "message": "Ελαχιστοποίηση Βίντεο"
  },
  "misc_3b692ea7": {
    "message": "Διάφορα"
  },
  "module_90d9fd32": {
    "message": "Ενότητα"
  },
  "modules_c4325335": {
    "message": "Ενότητες"
  },
  "my_files_2f621040": {
    "message": "Τα αρχεία μου"
  },
  "name_1aed4a1b": {
    "message": "Όνομα"
  },
  "navigation_ee9af92d": {
    "message": "Πλοήγηση"
  },
  "new_quiz_34aacba6": {
    "message": "Νέο Κουίζ"
  },
  "next_40e12421": {
    "message": "Επόμενο"
  },
  "no_e16d9132": {
    "message": "μη δημοσιευμένο"
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Δεν έχουν δημιουργηθεί σελίδες ακόμη."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Δεν υπάρχει διαθέσιμη προεπισκόπηση για αυτό το αρχείο."
  },
  "no_results_940393cf": {
    "message": "Δεν υπάρχουν Αποτελέσματα"
  },
  "no_results_found_58717065": {
    "message": "Δεν βρέθηκαν αποτελέσματα"
  },
  "none_3b5e34d2": {
    "message": "Κανένα"
  },
  "operators_a2ef9a93": {
    "message": "Χειριστές"
  },
  "options_3ab0ea65": {
    "message": "Επιλογές"
  },
  "orange_81386a62": {
    "message": "Πορτοκαλί"
  },
  "page_50c4823d": {
    "message": "Σελίδα"
  },
  "pages_e5414c2c": {
    "message": "Σελίδες"
  },
  "people_b4ebb13c": {
    "message": "Κοινό"
  },
  "percentage_34ab7c2c": {
    "message": "Εκατοστιαία αναλογία"
  },
  "pink_68ad45cb": {
    "message": "Ροζ"
  },
  "prev_f82cbc48": {
    "message": "Προηγούμενο"
  },
  "preview_53003fd2": {
    "message": "Προεπισκόπηση"
  },
  "previous_bd2ac015": {
    "message": "Προηγούμενο"
  },
  "published_c944a23d": {
    "message": "δημοσιευμένο/α"
  },
  "purple_7678a9fc": {
    "message": "Μοβ"
  },
  "quiz_e0dcce8f": {
    "message": "Κουίζ"
  },
  "quizzes_7e598f57": {
    "message": "Κουίζ"
  },
  "record_7c9448b": {
    "message": "Ηχογράφηση"
  },
  "recording_98da6bda": {
    "message": "Εγγράφεται"
  },
  "red_8258edf3": {
    "message": "Κόκκινο"
  },
  "relationships_6602af70": {
    "message": "Σχέσεις"
  },
  "remove_f47dc62a": {
    "message": "Αφαίρεση"
  },
  "replace_e61834a7": {
    "message": "Αντικατάσταση"
  },
  "reset_95a81614": {
    "message": "Επαναφορά"
  },
  "rich_content_editor_2708ef21": {
    "message": "Επεξεργαστής Πλούσιου Περιεχομένου-rich content"
  },
  "save_11a80ec3": {
    "message": "Αποθήκευση"
  },
  "search_280d00bd": {
    "message": "Αναζήτηση"
  },
  "selection_b52c4c5e": {
    "message": "Επιλογή"
  },
  "size_b30e1077": {
    "message": "Μέγεθος"
  },
  "star_8d156e09": {
    "message": " "
  },
  "start_over_f7552aa9": {
    "message": "Ξεκινήστε Ξανά"
  },
  "submit_a3cc6859": {
    "message": "Υποβολή"
  },
  "submitting_b90fac62": {
    "message": "Υποβολή σε εξέλιξη..."
  },
  "syllabus_f191f65b": {
    "message": "Αναλυτικό Πρόγραμμα"
  },
  "teal_f729a294": {
    "message": "Γαλαζοπράσινο"
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "<mrk mid=\"5994\" mtype=\"seg\">Η προεπισκόπηση του εγγράφου δημιουργείται αυτή τη στιγμή.</mrk> <mrk mid=\"5995\" mtype=\"seg\">Παρακαλώ δοκιμάστε ξανά αργότερα.</mrk>"
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "Το υλικό βρίσκεται στο δημόσιο domain"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "Το υλικό φέρει άδεια Creative Commons"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Αυτό το έγγραφο δεν μπορεί να εμφανιστεί μέσα στο Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Αυτή η εξίσωση δεν είναι δυνατό να αναπαραχθεί στην Βασική Μορφή"
  },
  "title_ee03d132": {
    "message": "Τίτλος"
  },
  "unpublished_dfd8801": {
    "message": "μη δημοσιευμένο"
  },
  "up_c553575d": {
    "message": "Επάνω"
  },
  "upload_file_fd2361b8": {
    "message": "Φόρτωση Αρχείου"
  },
  "upload_media_ce31135a": {
    "message": "Μεταφόρτωση Αρχείου Πολυμέσων"
  },
  "uploading_19e8a4e7": {
    "message": "Γίνεται φόρτωση..."
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Δικαίωμα Χρήσης:"
  },
  "video_player_b371005": {
    "message": "Πρόγραμμα Αναπαραγωγής Βίντεο"
  },
  "view_ba339f93": {
    "message": "Προβολή"
  },
  "white_87fa64fd": {
    "message": "Λευκό"
  },
  "wiki_home_9cd54d0": {
    "message": "Αρχική Σελίδα Wiki"
  },
  "yes_dde87d5": {
    "message": "Ναι"
  },
  "zoom_f3e54d69": {
    "message": "Μεγένθυνση"
  }
};
formatMessage.addLocale({
  el: locale
});